import { format } from "date-fns";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomButton } from "../../../components/CustomButton/CustomButton";
import styles from "../../../styles/customer-monitors.module.css";

export const ServiceInfo = ({
  service,
  typeOfAppointment = "",
  hideBorderBottom = false,
  roundedType = false,
  automaticMessages = false,
  showCommentButton = false,
  hasComments = false,
  onCommentClick,
}: {
  service: any;
  typeOfAppointment?: string;
  hideBorderBottom?: boolean;
  roundedType?: boolean;
  automaticMessages?: boolean;
  showCommentButton?: boolean;
  hasComments?: boolean;
  onCommentClick?: (service: any) => void;
}) => {
  const [t] = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const getBackgroundClass = (text: string) => {
    switch (text) {
      case "noInfestation":
        return styles["kein-befall"];
      case "infestation":
        return styles["befall"];
      case "maintenancePerformed":
        return styles["pflege"];
      case "unreachableOrMissing":
        return styles["nicht"];
      case "falseTriggered":
        return styles["false-triggered"];
      default:
        return "";
    }
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return moment(date).format("DD.MM.");
  };

  const capitalizeFirstLetter = (text: string): string => {
    if (!text || typeof text !== "string" || text.length === 0) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const getTraplinkedName = (type: string): string => {
    switch (type) {
      case "trap_triggered":
        return t("TrapTriggered");
      case "catch_detected":
        return t("CatchDetected");
      case "false_triggering":
        return t("FalseTriggering");
      default:
        return type;
    }
  };
  return (
    <div
      className={styles["last-service-item"]}
      style={{
        borderBottom: hideBorderBottom ? "none" : "0.5px solid #ced3dc",
      }}
    >
      <div className={styles["date"]} style={{ width: "fit-content" }}>
        {automaticMessages
          ? format(new Date(service?.localTimestamp), "dd.MM.yyyy")
          : formatDate(service?.changedAt)}
      </div>
      <div
        className={`${
          roundedType ? `${styles["rounded__type"]}` : styles["type"]
        }`}
      >
        {automaticMessages
          ? format(new Date(service.localTimestamp), "HH:mm:ss")
          : typeOfAppointment === "auftrag"
            ? "Bekämpfung"
            : typeOfAppointment === "other"
              ? "Sonstiges"
              : capitalizeFirstLetter(typeOfAppointment)}
      </div>
      {automaticMessages ? (
        <div className={styles["type-and-comment"]}>
          <div
            className={`${styles["type2"]} ${
              service.type === "false_triggering"
                ? getBackgroundClass("falseTriggered")
                : getBackgroundClass("infestation")
            }`}
          >
            {getTraplinkedName(service.type)}
          </div>
          {showCommentButton && (
            <div
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <CustomButton
                color={isHovered ? "lightGreen" : "lightGray"}
                icon={
                  hasComments
                    ? isHovered
                      ? "commentRedGreen"
                      : "commentRed"
                    : isHovered
                      ? "commentLight"
                      : "commentDark"
                }
                width={24}
                onClick={(e) => {
                  e.stopPropagation();
                  onCommentClick?.(service);
                }}
              />
            </div>
          )}
        </div>
      ) : (
        <div
          className={`${styles["type2"]} ${getBackgroundClass(
            service?.eventType
          )}`}
        >
          {t(capitalizeFirstLetter(service?.eventType ?? ""))}
        </div>
      )}
    </div>
  );
};
